import constants from "@/constants.js"
import CORE_CONFIG from "@core/config/app.config"

/**
 * Dev environment config begins
 */
CORE_CONFIG.COMMERCE_RAILS_BASE_URL= 'http://dev-commerce.maropost.com:5000'
CORE_CONFIG.AUTH_RAILS_BASE_URL= 'http://dev-commerce.maropost.com:5001'
CORE_CONFIG.SHA_KEY_RECORDS= '_key_9&si#7DH8!2Tk@1C6*d3_'
CORE_CONFIG.UNIFIED_BETA_ACCOUNTS= []

// Dev environment config ends
CORE_CONFIG.BEE_PAGE_CLIENT_ID = process.env.VUE_APP_BEE_PAGE_CLIENT_ID
CORE_CONFIG.BEE_PAGE_CLIENT_SECRET = process.env.VUE_APP_BEE_PAGE_CLIENT_SECRET
CORE_CONFIG.BEE_POPUP_CLIENT_ID = process.env.VUE_APP_BEE_POPUP_CLIENT_ID
CORE_CONFIG.BEE_POPUP_CLIENT_SECRET = process.env.VUE_APP_BEE_POPUP_CLIENT_SECRET
CORE_CONFIG.BEE_EMAIL_CLIENT_ID = process.env.VUE_APP_BEE_EMAIL_CLIENT_ID
CORE_CONFIG.BEE_EMAIL_CLIENT_SECRET = process.env.VUE_APP_BEE_EMAIL_CLIENT_SECRET
CORE_CONFIG.SPLIT_AUTHORIZATION_KEY = process.env.VUE_APP_SPLIT_AUTHORIZATION_KEY

if (process.env.NODE_ENV === 'production') {
  CORE_CONFIG.UNIFIED_BETA_ACCOUNTS = []
  CORE_CONFIG.COMMERCE_RAILS_BASE_URL = 'https://commerce-sandbox.maropost.com'
  CORE_CONFIG.AUTH_RAILS_BASE_URL = 'https://login-sandbox.maropost.com'
  const env = document.location.hostname.replace('.maropost.com', '')
  
  switch (env) {
    case 'app':
      break
  }
}
export default CORE_CONFIG
